<template>
  <div class="report-operate">
    <div class="tips-title">
      <slot name="title"></slot>
    </div>
    <div class="actions-container">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script lang="ts" setup name='report-operate'>
</script>

<style lang="scss" scoped>
  .report-operate {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;

    .tips-title {
      height: 30px;
      font-weight: 600;
      font-size: 14px;
      line-height: 30px;
    }

    .actions-container{
      display: flex;
      align-items: center;
    }
  }
</style>
